// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {deleteFile, getFiles} from '../../../product/shared/repositories';
import PictureRequestForm from '../state/picture-request-form';
import actions from '../actions-list';

export const updatePictRequestForm = partReturn =>

    dispatch => {

        dispatch({
            pictRequestForm: new PictureRequestForm({
                courierInfo: partReturn.courierInfo,
                files: partReturn.files,
                returnStatus: partReturn.allowedReturnStatuses.findIndex(item => item.id === partReturn.returnStatus.id) > -1 ?
                    partReturn.returnStatus :
                    partReturn.allowedReturnStatuses[0]
            }),
            type: actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM
        });

    };

export const updatePictRequestFormReturnStatus = returnStatus => ({
    returnStatus,
    type: actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_RETURN_STATUS
});

export const updatePictRequestFormComments = comments => ({
    comments,
    type: actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_COMMENTS
});

export const deletePictRequestFormFile = (fileToDelete, files) =>

    async dispatch => {

        const doesFileExist = files.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFile(fileToDelete);

                const filesArray = await getFiles(fileToDelete);

                dispatch({
                    files: filesArray,
                    type: actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };

export const addPictRequestFormFile = file => ({
    file,
    type: actions.ADD_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE
});



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/picture-request-form.js